import { FormattedMessage, injectIntl } from "react-intl";
import PropTypes from "prop-types";
import React, { Component } from "react";
import Alert from "react-bootstrap/Alert";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

class JwtExpiredModalDialog extends Component {
  constructor(props) {
    super(props);
    this.handleConfirmation = this.handleConfirmation.bind(this);
  }

  handleConfirmation() {
    this.props.onClose();
  }

  render() {
    let { show } = this.props;

    return (
      <Modal show={show} enforceFocus autoFocus>
        <Modal.Header>
          <Modal.Title>
            <FontAwesomeIcon icon={faExclamationTriangle} size="lg" /> <FormattedMessage id="app.session.expired" />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alert variant="warning">
            <FormattedMessage id="heartbeat.jwt.verification" />
          </Alert>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={this.handleConfirmation}>
            <FormattedMessage id="confirmDialog.ok" />
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

JwtExpiredModalDialog.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func.isRequired
};

export default injectIntl(JwtExpiredModalDialog);
